import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE, TOTAL_VALUE, SAVINGS } from '../lib/config';
const volumes = ['Volume 1 — The Discovery & Onboarding Manifesto', "Volume 2 — The Architect's Blueprint", 'Volume 3 — The Design & Aesthetic Strategy', 'Volume 4 — The Vendor Command & Control', 'Volume 5 — The “Day-Of” Emergency Protocols ⭐', 'Volume 6 — The Profit & Legacy System'];
const bonuses = ['Bonus 1 — Luxury Client Email Swipe File', 'Bonus 2 — Quick-Start Checklist', 'Bonus 3 — Premium Client Welcome Pack Template', 'Bonus 4 — Vendor Follow-Up Script Kit', 'Bonus 5 — Wedding Day Pocket Command Sheet'];
export function Pricing() {
  return <section id="pricing" className="w-full bg-ivory py-16 sm:py-24" data-id="element-165" data-mp="3h6le9yel4la3">
      <div className="mx-auto max-w-3xl px-5" data-id="element-166" data-mp="3c8a57pw46esx">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-167" data-mp="3c7i9mf2ioh2n">
          Get the complete system today
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-168" data-mp="3w1jjudic9444" />

        <div className="mt-12 border border-gold bg-white shadow-card" data-id="element-169" data-mp="4rksrs73dz2t">
          <div className="border-b border-gold-soft/70 bg-gold-tint px-7 py-8 text-center" data-id="element-170" data-mp="9ryy32hb6ux5">
            <h3 className="font-serif text-2xl sm:text-3xl text-ink" data-id="element-171" data-mp="erldnikm0n94">
              The Wedding Pro OS™ — Complete Edition
            </h3>
            <p className="mt-3 text-sm text-ink-soft" data-id="element-172" data-mp="3dasc1ge01lru">
              Everything you need to run a high-end wedding planning business
            </p>
          </div>

          <div className="grid gap-x-10 gap-y-3 px-7 py-9 sm:grid-cols-2" data-id="element-173" data-mp="3n6veyogodofu">
            {volumes.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink" data-id="element-174" data-mp="3ryn3yuk6nm3v">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-175" data-mp="2uheo3v8peflq" />
                {item}
              </p>)}
            {bonuses.map(item => <p key={item} className="flex items-start gap-3 text-[15px] text-ink-soft" data-id="element-176" data-mp="2reryxyyzyiu8">
                <GiftIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-177" data-mp="2mhi4u60nxj02" />
                {item}
              </p>)}
          </div>

          <div className="border-t border-gold-soft/70 px-7 py-9 text-center" data-id="element-178" data-mp="2w9xn74fvg9lh">
            <p className="text-[11px] uppercase tracking-[0.24em] text-ink-muted" data-id="element-179" data-mp="28i8yrz66859t">
              Total value: {TOTAL_VALUE}
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-180" data-mp="2ifwrkjk7v2pc">
              Regular price: <s data-id="element-181" data-mp="2idtuxgok6bbn">{ANCHOR_PRICE} USD</s>
            </p>
            <p className="mt-2 flex items-end justify-center gap-2" data-id="element-182" data-mp="2dg21gi89mh5c">
              <span className="font-serif text-6xl leading-none text-ink" data-id="element-183" data-mp="3tv3e023rz1cf">{PRICE}</span>
              <span className="pb-2 text-xs uppercase tracking-[0.2em] text-ink-muted" data-id="element-184" data-mp="3ow8vl19pzesu">
                USD
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] uppercase tracking-[0.16em]" data-id="element-185" data-mp="9lzi8fa1c6g">
              <li className="bg-ink px-3 py-1.5 text-gold" data-id="element-186" data-mp="57drf2fx8yan">Save {SAVINGS}</li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-187" data-mp="3ngo3apq1fwxh">
                One-time payment
              </li>
              <li className="border border-gold-soft px-3 py-1.5 text-ink-soft" data-id="element-188" data-mp="3rihwye1tg0o5">
                Lifetime access
              </li>
            </ul>

            <p className="mt-8 text-xs italic text-ink-muted" data-id="element-189" data-mp="nywv7bhrsgdq">
              You will be charged in your local currency.
            </p>

            <div className="mt-4" data-id="element-190" data-mp="a6gu4g8fisfg">
              <CtaButton href={CHECKOUT_URL} className="w-full sm:w-auto" data-id="element-191" data-mp="e9myfibze9ja">
                Yes, I want the Wedding Pro OS
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-192" data-mp="11xwhwdlq2l79">
              <li className="inline-flex items-center gap-2" data-id="element-193" data-mp="3f8jvmcafmj5r">
                <LockIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-194" data-mp="3a8feql5m3mf0" />
                Secure checkout
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-195" data-mp="35adw21c3lp42">
                <ZapIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-196" data-mp="317r1vtryfs3p" />
                Instant download
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-197" data-mp="1rkms0qcrmfp">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-198" data-mp="3syx72omj8fzu" />
                7-day guarantee
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}